<template>
  <div class="ls-nav-item">
    <span>{{ title }}</span>
    <LsIcon type="chevron" color="primary" size="md" />
  </div>
</template>

<script>
import { LsIcon } from '@/components/common';
import VueTypes from 'vue-types';

export default {
  name: 'LsNavItem',
  components: {
    LsIcon,
  },
  props: {
    title: VueTypes.string.isRequired,
  },
};
</script>

<style lang="scss" scoped>
.ls-nav-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;
  border-bottom: 1px solid $primary-light;
  cursor: pointer;
  &:hover {
    color: $primary;
  }
}
.themed-app {
  .ls-nav-item {
    border-color: $theme-color-primary-light;
    &:hover {
      color: $theme-color-primary;
    }
  }
}
</style>
